import * as React from "react";
import { forwardRef } from "react";
const SvgClockCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.5 19.9856L16.5 21.9856L21 17.4856M21.9851 13.5355C21.995 13.3534 22 13.1701 22 12.9856C22 7.46275 17.5228 2.9856 12 2.9856C6.47715 2.9856 2 7.46275 2 12.9856C2 18.421 6.33651 22.8436 11.7385 22.9822M12 6.9856V12.9856L15.7384 14.8548", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgClockCheck);
export default ForwardRef;
